module.exports = __webpack_public_path__ + "img/2.9fe1f7c3.png";